import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';

const TrainingClassCard = ({ instance }) => {
    const router = useRouter();

    const scheduledAt = new Date(instance.scheduledAt);
    const dateStr = scheduledAt.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
    const timeStr = scheduledAt.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

    return (
        <Pressable
            style={styles.card}
            onPress={() => router.push(`/training/${instance.moduleID}`)}
        >
            <View style={styles.iconContainer}>
                <Unicon name="school-outline" size={18} colorVariant="primary" />
            </View>
            <View style={styles.content}>
                <Text style={styles.className} numberOfLines={1}>{instance.className}</Text>
                <Text style={styles.moduleName} numberOfLines={1}>{instance.moduleName}</Text>
                <Text style={styles.dateText}>{dateStr} at {timeStr}</Text>
            </View>
            <Unicon name="chevron-forward-outline" size={16} colorVariant="textSecondary" />
        </Pressable>
    );
};

const styles = StyleSheet.create(({ colors, fonts }) => ({
    card: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 10,
        paddingHorizontal: 12,
        backgroundColor: colors.surface,
        borderRadius: 10,
        marginBottom: 6,
        borderWidth: 0,
        gap: 10,
    },
    iconContainer: {
        width: 34,
        height: 34,
        borderRadius: 10,
        backgroundColor: colors.primaryContainer,
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    content: {
        flex: 1,
        minWidth: 0,
    },
    className: {
        fontSize: 14,
        fontFamily: fonts.heading,
        color: colors.text,
    },
    moduleName: {
        fontSize: 12,
        fontFamily: fonts.body,
        color: colors.textSecondary,
        marginTop: 1,
    },
    dateText: {
        fontSize: 11,
        fontFamily: fonts.body,
        color: colors.primary,
        marginTop: 2,
    },
}));

export default TrainingClassCard;
